import PropTypes from 'prop-types';
import { TripType } from './TripType';
import { Config } from '../utils';

const EnabledType = PropTypes.shape({
    enabled: PropTypes.bool.isRequired
});
const SwapButtonType = PropTypes.shape({
    visible: PropTypes.bool.isRequired
});
const AddFlightButtonType = PropTypes.shape({
    label: PropTypes.string.isRequired
});
const MaxSegmentsType = PropTypes.shape({
    [TripType.ONE_WAY]: PropTypes.number.isRequired,
    [TripType.MULTIPLE]: PropTypes.number.isRequired,
});
const DateRangeType = PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number
});

export const SegmentConfigType = PropTypes.shape({
    origin: EnabledType.isRequired,
    destination: EnabledType.isRequired,
});

export const ConfigProp = PropTypes.shape({
    segments: PropTypes.arrayOf(SegmentConfigType).isRequired,
    swapButton: SwapButtonType.isRequired,
    addFlightButton: AddFlightButtonType.isRequired,
    airlineCheckbox: EnabledType.isRequired,
    maxSegments: MaxSegmentsType.isRequired,
    dateRange: PropTypes.arrayOf(DateRangeType).isRequired,
    autofillLastDestination: PropTypes.bool.isRequired,
});

export const DEFAULT_MAX_SEGMENTS = 3;
const websiteMaxMultipleDestinations =
    Config?.get('websiteMaxMultipleDestinations')
    || window.reactContext?.websiteMaxMultipleDestinations
    || DEFAULT_MAX_SEGMENTS;

export const SegmentPropDefault = Object.freeze({
    origin: { enabled: true },
    destination: { enabled: true },
});

export const DateRangePropDefault = Object.freeze({
    min: 0,
    max: 0,
});

export const ConfigPropDefault = Object.freeze({
    segments: Array(websiteMaxMultipleDestinations).fill(SegmentPropDefault),
    swapButton: {
        visible: true,
    },
    addFlightButton: {
        label: 'flightsManager.add.another.oneWay.flight',
    },
    airlineCheckbox: {
        enabled: true,
    },
    maxSegments: {
        [TripType.ONE_WAY]: 3,
        [TripType.MULTIPLE]: websiteMaxMultipleDestinations,
    },
    dateRange: Array(websiteMaxMultipleDestinations).fill(DateRangePropDefault),
    autofillLastDestination: false,
});

export const ConfigPropDefaultTrains = Object.freeze({
    swapButton: {
        visible: true,
    },
    airlineCheckbox: {
        enabled: true,
    },
    maxSegments: {
        [TripType.ONE_WAY]: 1,
        [TripType.MULTIPLE]: websiteMaxMultipleDestinations,
    },
    dateRange: Array(websiteMaxMultipleDestinations).fill(DateRangePropDefault),
    autofillLastDestination: false,
});

export const searcherConfigs = Object.freeze({
    default: ConfigPropDefault,
    trains: ConfigPropDefaultTrains,
    QR: {
        segments: [
            {
                origin: { enabled: true },
                destination: { enabled: false },
            },
            {
                origin: { enabled: false },
                destination: { enabled: true },
            },
            SegmentPropDefault,
        ],
        swapButton: {
            visible: false,
        },
        addFlightButton: {
            label: 'flightsManager.add.another.stopover.flight',
        },
        airlineCheckbox: {
            enabled: false,
        },
        maxSegments: {
            [TripType.ONE_WAY]: 3,
            [TripType.MULTIPLE]: 3,
        },
        dateRange: [
            DateRangePropDefault,
            {
                min: 1,
                max: 4,
            },
            DateRangePropDefault,
        ],
        autofillLastDestination: true,
    }
});

